import type { InsuranceCoverage } from "@/types/insurance-coverage";

import { listInsuranceCoverages } from "./insurance";

export const insuranceQueryKeys = {
  all: ["user", "patient", "insurance-coverages"] as const,
  list: (patientId: string) => [...insuranceQueryKeys.all, patientId] as const,
};

export const insuranceQueryOptions = {
  list: (patientId: string) => ({
    queryKey: insuranceQueryKeys.list(patientId),
    queryFn: () => listInsuranceCoverages(patientId),
    select: (data: InsuranceCoverage[] | null) => data ?? [],
  }),
};
